import * as React from 'react'

function IconBookmark(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={52}
      height={81}
      viewBox="0 0 52 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M51.21 80.4l-25.6-17.09L0 80.4V0h51.21v80.4z" fill="#E84E25" />
    </svg>
  )
}

export default IconBookmark
